<template lang="pug">
  v-container.pa-5(fluid grid-list-md fill-height)
    c-alert(ref="alert")
    v-layout(column)
      v-flex
        v-layout(row)
          v-flex(xs4 d-flex align-center)
            v-icon.pr-2(size="40") swap_vertical_circle
            v-flex
              .headline Hotel Link Solution
              .overline Data synchronize
          v-flex(xs8 d-flex justify-end align-center)
            v-btn(@click="$refs.upload.click()")
              input(ref="upload" type="file" @change="onFileSeleceted")
              v-icon(left) cloud_upload
              | UPLOAD

      v-flex
        v-card
          v-card-text
            v-stepper
              v-stepper-header
                v-stepper-step(:complete="state >= STATE.UPLOAD" step="1") Upload
                v-divider
                v-stepper-step(:complete="state >= STATE.PREVIEW" step="2") Preview
                v-divider
                v-stepper-step(:complete="state >= STATE.SYNC" step="3") Sync
                v-divider
                v-stepper-step(:complete="state >= STATE.FINISH" step="4") Finish

      v-flex
        v-card
          v-card-text
            c-form(:headers="headers" :syncing="syncing" @update="settings = arguments[0]" @submit="doSubmit")

      v-flex(fill-height)
        v-card
          v-card-text
            c-table(:headers="headers" :items="items" :selected="settings.column")
</template>

<script>
import Papa from 'papaparse'
import CAlert from '@/components/commons/DialogAlert'
import CTable from '@/components/commons/SyncTable'
import CForm from './Form'
import sendHotelLinkUpdate from '@/services/hotellink'

const STATE = {
  UPLOAD: 0,
  PREVIEW: 1,
  SYNC: 2,
  FINISH: 3
}

export default {
  components: {
    CAlert,
    CTable,
    CForm
  },
  data () {
    return {
      STATE,
      state: null,
      headers: [],
      items: [],
      settings: {
        column: -1,
        apiUsername: null,
        apiPassword: null,
        apiSecret: null
      },
      syncing: false
    }
  },
  mounted () {
    this.state = STATE.UPLOAD
  },
  methods: {
    async onFileSeleceted (e) {
      const target = e.target
      if (target.files.length === 0) {
        return
      }

      const file = target.files[0]
      const allows = ['text/csv', 'application/vnd.ms-excel']
      if (allows.indexOf(file.type) === -1) {
        return alert('Please select *.csv file, other formats are not allowed')
      }

      const rows = await this.doReadCSV(file)
      this.headers = rows[0].map((val, idx) => ({ text: val, value: idx }))
      this.items = rows.slice(1).map(row => ({ ...row }))
      this.state = STATE.PREVIEW
    },

    doReadCSV (file) {
      return new Promise((resolve, reject) => {
        Papa.parse(file, {
          complete: (result) => resolve(result.data),
          error: reject
        })
      })
    },

    async doSubmit () {
      const data = this.settings
      this.state = STATE.SYNC
      this.syncing = true

      try {
        const col = data.column
        const bookingIds = this.items.map(item => (item[col])).filter(n => n)
        const response = await sendHotelLinkUpdate(data.apiUsername, data.apiPassword, data.apiSecret, bookingIds)
        this.doUpdateResult(response.data)
        this.doFinish()
      } catch (e) {
        alert(e.toString())
        this.doError()
      }
    },

    doFinish (data) {
      this.state = STATE.FINISH
      this.syncing = false
    },

    doError () {
      this.state = STATE.PREVIEW
      this.syncing = false
    },

    doUpdateResult (data) {
      const msg = data.message
      const bookingIds = data.data || []
      if (msg !== '') {
        this.$refs.alert.doOpen({ message: msg })
        return
      }

      const col = this.settings.column
      this.items.forEach(item => {
        const id = item[col]
        if (bookingIds.indexOf(id) !== -1) {
          this.$set(item, '$status', 'SUCCESS')
        }
      })

      const success = `Update completed, ${bookingIds.length} of booking has been updated`
      this.$refs.alert.doOpen({ message: success })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@uppy/core/dist/style.css'
@import '~@uppy/drag-drop/dist/style.css'

.head
  .layout
    h1
      font-size: 1.2rem

.v-stepper
  box-shadow: none
  background: none
  color: none

  >>> &__header
    height: 42px

  >>> &__step
    padding: 0 24px

.table
  .v-card
    min-height: 100%

    &__text
      min-height: 100%

.v-btn
  input[type='file']
    display: none
</style>
